import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import SegmentedSwitch from './segmented-switch';

const SIZE_OPTIONS = [
  { value: 'small', label: 'Small' },
  { value: 'medium', label: 'Medium' },
  { value: 'large', label: 'Large' },
];

interface SizeSwitchControlProps {
  value: string;
  onChange: (value: string) => void;
}

// shared "Size" section (Small/Medium/Large segmented switch), for widgets with a fixed 3-tier
// size preset - distinct from SizeControl, which is media's Original/Fill/Scale switch
export default function SizeSwitchControl({ value, onChange }: SizeSwitchControlProps) {
  return (
    <Container className="flex-column gap-8">
      <Text tag="label" design="GlobalIcoText3" className="L2 padding-l-16">
        Size
      </Text>
      <SegmentedSwitch fullWidth value={value} options={SIZE_OPTIONS} onChange={onChange} />
    </Container>
  );
}
